import { HStack, Stack, Text } from "@chakra-ui/react";
import { useConfigurationMenu } from "@raiden/library/hooks/useConfigurationMenu";
import { memo } from "react";
import { FormattedMessage } from "react-intl";
import { MenuItem } from "./MenuItem";

export const SocialNetworks = memo(function SocialNetworks() {
  const { menu } = useConfigurationMenu({ alias: "social-networks" });

  if (!menu || menu.items.length === 0) {
    return null;
  }

  return (
    <Stack>
      <Text variant="text-moyen">
        <FormattedMessage defaultMessage="Retrouvez-nous sur les réseaux sociaux" />
      </Text>

      <Stack spacing="0.75rem">
        {menu?.items?.map((menuItem, index) => {
          return (
            <HStack key={index}>
              <MenuItem menuItem={menuItem} />
            </HStack>
          );
        })}
      </Stack>
    </Stack>
  );
});
